import { CSSProperties } from "react";

const ErrorSlate = ({
  message,
  style,
}: {
  message: string | undefined;
  style?: CSSProperties;
}) => {
  return (
    <div
      role="alert"
      style={{
        fontSize: "0.75rem",
        fontWeight: 500,
        padding: "4px 0",
        width: "100%",
        color: "#dc2626",
        lineHeight: 1.4,
        ...style,
      }}
    >
      {typeof message === "string"
        ? message
        : Array.isArray(message)
          ? String(message?.[0])
          : "An unkown error occured while processing this request"}
    </div>
  );
};

export default ErrorSlate;
